export default __webpack_public_path__ + "static/media/bg_merchant_login.9ee587b1.jpeg";